module.exports = __webpack_public_path__ + "static/media/m_beard_medium_diamond__v_2.d8d329a3.png";